import { DbSaveCargo } from "../../../data/usecases/save-cargo";
import { SaveCargo } from "../../../domain/usecases/save-cargo";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbSaveCargo = (): SaveCargo =>
  new DbSaveCargo(makeApiUrl("/cargo"), makeAuthorizeHttpClientDecorator());
